import useDisclosure from 'app/src/hooks/useDisclosure'
import HeaderActions from 'app/src/layouts/HeaderActions'
import FeatureToggleModal from 'app/src/me/FeatureToggleModal'

const FeatureToggle = () => {
  const { isOpen, close } = useDisclosure(true)

  return (
    <>
      <HeaderActions />
      <FeatureToggleModal isOpen={isOpen} close={close} />
    </>
  )
}

export const Component = FeatureToggle
export default FeatureToggle
